<!--
일괄기능-아이템 체커( 체크박스 )
------------------------------------

-->
<template>
    <input class="uk-checkbox" type="checkbox" :value="item.id" v-model="item.checked"/>
</template>

<script>
    export default {
        props: {
            /**
             * 아이템 정보 (상세정의는 컨트롤러 참고)
             */
            item: Object
        },
        data: function () {
            return {
            };
        },
        mounted: function () {
            // 초기에 item에 checked 항목이없으면 생성해줌.
            if (this.item.checked === undefined) {
                this.item.checked = false;
            }
        },
        computed: { 
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>

</style>